<template>
  <div v-if="arquivosARR.length != 0">
    <h3 class="rs-data-title">Liberações</h3>
    <div :style="'display: flex; flex-direction: row; justify-content: space-around;'">
      <div :style="'display: flex; flex-direction: row'">
        <h4 class="rs-data-title">Liberados:</h4>
        <h4 class="rs-data-title">{{arquivosARR.length}}</h4>
      </div>
      <div :style="'display: flex; flex-direction: row'">
        <h4 class="rs-data-title">Pendentes: </h4>
        <h4 class="rs-data-title">{{arquivosARR.filter((e) => {return e.VERSAOATUAL != versao.VERVERSAOSETUP }).length}}</h4>
      </div>
      <div :style="'display: flex; flex-direction: row'">
        <h4 class="rs-data-title">Recebidos: </h4>
        <h4 class="rs-data-title">{{arquivosARR.filter((e) => {return e.ARQCLISITUACAO > 1 }).length}}</h4>
      </div>
      <div :style="'display: flex; flex-direction: row'">
        <h4 class="rs-data-title">Atualizados: </h4>
        <h4 class="rs-data-title">{{arquivosARR.filter((e) => {return e.VERSAOATUAL == versao.VERVERSAOSETUP }).length}}</h4>
      </div>
    </div>
    <div style="margin: 10px;">
      <v-progress-linear color="#66cc66" background-color="#dddddd" :value="arquivosARR.filter((e) => {return e.ARQCLISITUACAO > 1 }).length / arquivosARR.length * 100" style="width: 90%; margin-left: 50px; margin-right: 50px; position: absolute;" />
      <v-progress-linear color="#6699ff" background-color="#dddddd" :value="arquivosARR.filter((e) => {return e.VERSAOATUAL == versao.VERVERSAOSETUP }).length / arquivosARR.length * 100" style="width: 90%; margin-left: 50px; margin-right: 50px; position: absolute;" />
    </div>
    <v-data-table
      dense
      hide-actions
      :headers="headers"
      class="elevation-1"
      :items="arquivosARR"
      item-key="ARQMD5"
      style="margin-top: 40px"
      no-results-text="Nada foi encontrado."
    >
      <template v-slot:items="props">
        <tr>
          <td>{{props.item.CLINOMEUSUAL}}</td>
          <td>{{props.item.ARQCLISITUACAO == 0 ? "Pendente" : props.item.ARQCLISITUACAO == 1 ? "Baixando" : "Recebido"}}</td>
          <td>{{props.item.ARQCLITIPODOWNLOAD == 1 ? "Instalação Forçada" : props.item.ARQCLITIPODOWNLOAD == 0 ? "Critério do Cliente" : "Download Silencioso"}}</td>
          <td>{{props.item.ARQDATAHORACONF | formatDateNormal}}</td>
          <td>
            {{props.item.VERSAOATUAL}}
            <md-icon class="rs-priority-icon" v-if="props.item.VERSAOATUAL == versao.VERVERSAOSETUP" style="color: #66bb66;">check</md-icon>
          </td>
        </tr>
      </template>

      <template v-slot:expand="props">
      </template>
    </v-data-table>  
  </div>
</template>
<script>
import * as Arquivos from "../../providers/arquivos.service";
export default {
  props: ["versao"],
  data() {
    return {
      arquivosARR: [],
        headers: [
          {
            text: "Cliente",
            value: "CLINOMEUSUAL"
          },
          {
            text: "Situação",
            value: "ARQCLISITUACAO"
          },
          {
            text: "Tipo de Instalação",
            value: "ARQCLITIPODOWNLOAD"
          },
          {
            text: "Data",
            value: "ARQDATAHORACONF"
          },
          {
            text: "Versão Atual",
            value: "VERSAOATUAL"
          }
        ]
    };
  },
  created() {
    debugger;
    this.getLiberados(this.versao);
  },
  methods: {
    getLiberados(versao) {
      var self = this;
      Arquivos.listaArquivosLiberados({ ARQMD5: versao.VERMD5SETUP }).then(
        r => {
          self.arquivosARR = r.Rows.map((e) => {
            debugger
            if (e.VERSAOATUAL)
                e.VERSAOATUAL = e.VERSAOATUAL.split('.').map((ex) => {return parseInt(ex).toString()}).join('.');
            return e;
          });          
        }
      );
    }
  }
};
</script>
<style scoped>
table {
  width: 100%;
}

td,
th {
  border: 1px solid rgb(233, 233, 233);
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #CFDFE5;
}

.subtitle-2 {
  min-height: 30px;
}
.overlayy {
  z-index: 10;
  background: rgba(0, 0, 0, 0.39);
  position: absolute;
  width: 100%;
  height: 99%;
  top: 0;
  border-radius: 5px;
  left: 0;
}
li {
  min-height: 58px;
}

span,
div,
table,
td,
tr,
th {
  transition: all 0.3s ease !important;
}

/*.md-theme-default a:not(.md-button) {
  color: #2b5577 !important;
}*/

.md-theme-default a:hover {
  color: #00aaff !important;
  text-decoration: underline !important;
}

table.v-table tbody td, table.v-table tbody th{
  height: 25px;
}

.rs-data-title{
  display: flex;
  justify-content: center;
}

.rs-priority-icon{
  margin-right: 10px;
  font-size: 20px !important;
}

</style>